﻿import { Component, Inject} from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from './_services';
import { User } from './_models';
import { RestService } from './_services/rest.service';
import { DOCUMENT } from '@angular/common';



@Component({ selector: 'app-root', templateUrl: 'app.component.html'

})
export class AppComponent {

    currentUser: User;

    interhouses: boolean = false;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private restService: RestService,
        @Inject(DOCUMENT) document) {

        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.restService.getParam('mail').subscribe(data => {
            if (data && data.valor) {
                const mail = document.getElementById('mail') as HTMLElement;
                mail.innerText = data.valor;
                mail.setAttribute('href', 'mailto:' + data.valor);
            }        
        });
        this.restService.getParam('cargar.detalle.interhouses').subscribe(data => {
            this.interhouses = "true" === data.valor.toLowerCase();
        });

    }


    hasRol(rolName: string): boolean {
        return this.authenticationService.hasRol(rolName);
    }

    entrarOSalir() {
        if (this.currentUser) {
            this.authenticationService.logout();
            this.router.navigate(['/']);
        } else {
            this.router.navigate(['/login']);
        }
    }

    currentYear() {
        return (new Date()).getFullYear();
    }

    print() {
        window.print();
    }

}
